import React, { useState } from 'react'

import { usePet } from '../../modules'
import Confirm from '../reusable/confirm'

import Modal from "../reusable/modal"

const CancelItem = ({ toggle, visible, item, onPerform }) => {
    const [reason, setReason] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Item has been cancelled', ops('success'))        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('toggleCancelBilledItem', {
        id: item?._id,
        reason
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Cancelling this item...' } })

    return (
        <Modal
            w={ 400 }
            title="Cancel Item"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Reason
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        rows="4"
                        value={ reason }
                        onChange={ e => setReason(e.target.value)}
                        placeholder="Please indicate why you are cancelling this item." />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading || reason?.length < 5 } onClick={ () => reason?.length >= 5 && Confirm({
                    title: 'Cancel This Item',
                    message: 'Please confirm before performing this action',
                    okText: 'Cancel Item',
                    onOk: execute
                }) } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Cancel Item</button>
            </div>
        </Modal>
    )
}

export default CancelItem